export default "__VITE_ASSET__CnyOeNcU__"